import { getInputIdFormContext } from '@/utils';
import { useFormContext } from 'react-hook-form';

import { COLORS } from '@/utils/constants';

import { default as InputWithTitle, Props } from './InputWithTitle';

type PropsPass = Props & { currentId: string };

export const InputFormContext = ({
  currentId,
  currentValue,
  maxLength,
  textColor = COLORS.tundora,
  inputProps,
  actualLength,
  fieldError,
  infoText,
  infoBoolean,
  disabled,
  ...res
}: PropsPass) => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const error = getInputIdFormContext(errors, currentId);

  const errorMessage = error?.message;

  // Compose input props to make sure both react-hook-form's register handlers
  // and custom input props (like onChange passed from parent) are executed.
  const registerProps = register(currentId);

  const composedInputProps: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > = {
    ...registerProps,
    // Merge props so custom handlers run after form registration handlers.
    ...inputProps,
    onChange: (e: any) => {
      // call register's onChange first to update RHF state
      if ((registerProps as any).onChange) (registerProps as any).onChange(e);
      if (inputProps && inputProps.onChange) inputProps.onChange(e);
    },
    onBlur: (e: any) => {
      if ((registerProps as any).onBlur) (registerProps as any).onBlur(e);
      if (inputProps && inputProps.onBlur) inputProps.onBlur(e);
    },
  };

  return (
    <>
      <InputWithTitle
        disabled={disabled}
        currentValue={currentValue}
        {...res}
        actualLength={watch(currentId)?.length || 0}
        maxLength={maxLength}
        infoBoolean={infoBoolean}
        infoText={infoText}
        textColor={textColor}
        inputProps={composedInputProps}
        fieldError={errorMessage}
      />
    </>
  );
};

export default InputFormContext;
